__turbopack_context__.v({
  "control": "control-row-module__Go9rvG__control",
  "label": "control-row-module__Go9rvG__label",
  "row": "control-row-module__Go9rvG__row",
});
